export class QCWorkflowObjective {
  constructor(
    public id: number,
    public task: string,
    public isDeleted: boolean = false,
  ) {}
}

export class MediaQCWorkflowObjective extends QCWorkflowObjective {
  constructor(
    public id: number,
    public objectiveId: number,
    public task: string,
    public description: string,
    public mediaId: number,
    public userId: string,
    public updatedDate: number,
    public status: MediaQCWorkflowObjectiveStatus,
    public previousStatus: MediaQCWorkflowObjectiveStatus,
  ) {
    super(id, task);
  }
}

export enum MediaQCWorkflowObjectiveStatus {
  NotChecked = 0,
  Failed = 1,
  Passed = 2,
}

export class MediaQCWorkflowObjectiveGetSpecifications {
  constructor(public mediaId: number) {}
}

export class MediaQCWorkflowObjectiveUpdateSpecifications {
  constructor(
    public mediaId: number,
    public objectives: MediaQCWorkflowObjective[],
  ) {}
}
